module.exports = __webpack_public_path__ + "img/aside-image.869367f7.webp";